import { render, staticRenderFns } from "./CallCordova.vue?vue&type=template&id=ab107e82&"
import script from "./CallCordova.vue?vue&type=script&lang=js&"
export * from "./CallCordova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports